var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLt = function SvgLt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    transform: "scale(.64143 .96773)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1063,
    height: 708.7,
    fill: "#006a44",
    rx: 0,
    ry: 0,
    transform: "scale(.93865 .69686)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1063,
    height: 236.2,
    y: 475.6,
    fill: "#c1272d",
    rx: 0,
    ry: 0,
    transform: "scale(.93865 .69686)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdb913",
    d: "M0 0h997.8v164.6H0z"
  }))));
};
export default SvgLt;